import { ReactElement } from 'react';
import { isMobile } from '@client/common/utils/env';
import { useTranslate } from '@client/i18n/hooks';
import { SearchField as SearchFieldComponent } from 'b2b-components/theme/components/Header/SearchField';
import { Props } from './SearchField.types';
import './SearchField.scss';

export const SearchField = (props: Props): ReactElement => {
  const t = useTranslate();
  const { deviceType } = props;

  const placeholder = isMobile(deviceType)
    ? t('Search')
    : t('article name, sku, serial number, invoice number, etc...');

  return (
    <SearchFieldComponent
      {...props}
      className='RmaSearchField'
      placeholder={placeholder}
      dataAttributes={{ 'data-hj-suppress': true }}
    />
  );
};
